import { computed, type Ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { useApi } from '@shopexperts/shared';
import { useAuthStore } from '@/store/auth';

export function useExpertProjects(clientId: Ref<number | undefined>) {
  const api = useApi();
  const auth = useAuthStore();
  const query = useQuery({
    queryKey: computed(() => ['expert', 'review-projects', auth.user?.id, clientId.value]),
    queryFn: () => api.expert.reviewsV2.getClientProjects({
      params: { clientId: clientId.value! }, query: { page: 1 },
    }),
    enabled: computed(() => !!clientId.value && !!auth.user?.id),
    staleTime: 0,
  });
  return {
    projects: computed(() => query.data.value?.data.slice(0, 50) ?? []),
    isLoadingProjects: query.isLoading,
    projectsError: query.error,
    refetchProjects: query.refetch,
  };
}
